import axios from 'axios';
import logComponent from '../logComponent';
import getConfig from './getConfig';

const Group = (function() {
  function DeleteGroup(groupId) {
    if (logComponent('Group')) { console.debug('Group DeleteGroup'); }
    return axios.delete(`api/Group/${groupId}`, getConfig());
  }

  function GetUsers(groupId) {
    if (logComponent('Group')) { console.debug('Group GetUsers'); }
    const params = { groupId };
    return axios.get('api/Group/GetUsers', getConfig( params));
  }

  function GetModules(groupId) {
    if (logComponent('Group')) { console.debug('Group GetModules'); }
    const params = { groupId };
    return axios.get('api/Group/GetModules', getConfig( params));
  }

  function AddOrUpdate(group) {
    if (logComponent('Group')) { console.debug('Group AddOrUpdate'); }
    return axios.put('api/Group/AddOrUpdate', group, getConfig());
  }

  // NOTE: users = { groupId: int, userIds: [int] }
  function AddUsers(users) {
    if (logComponent('Group')) { console.debug('Group AddUsers'); }
    return axios.post('api/Group/AddUsers', users, getConfig());
  }

  // NOTE: users = { groupId: int, userIds: [int] }
  function RemoveUsers(users) {
    if (logComponent('Group')) { console.debug('Group RemoveUsers'); }
    return axios.delete('api/Group/RemoveUsers', getConfig( null, users));    
  }

  function SetModules(groupId, moduleIds) {
    if (logComponent('Group')) { console.debug('Group SetModules'); }
    const data = { groupId, moduleIds };
    return axios.put('api/Group/SetModules', data, getConfig());
  }

  // NOTE: groupSurveyTypeIds = [{ surveyTypeId: int, surveyId: int }]
  function AddGroupSurveyTypes(groupId, groupSurveyTypeIds) {
    if (logComponent('Group')) { console.debug('Group AddGroupSurveyTypes'); }
    const data = { groupId, groupSurveyTypeIds };
    return axios.post('api/Group/AddGroupSurveyTypes', data, getConfig())
  }

  // NOTE: groupSurveyTypeIds = [{ surveyTypeId: int, surveyId: int }]
  function RemoveGroupSurveyTypes(groupId, groupSurveyTypeIds) {
    if (logComponent('Group')) { console.debug('Group RemoveGroupSurveyTypes'); }
    const data = { groupId, groupSurveyTypeIds };
    return axios.delete('api/Group/RemoveGroupSurveyTypes', getConfig(null, data));
  }

  function GetGroupCheckInSurvey(groupId) {
    if (logComponent('Group')) { console.debug('Group GetGroupCheckInSurvey'); }
    const params = { groupId };
    return axios.get('api/Group/GetGroupCheckInSurvey', getConfig(params));
  }

  return {
    Id: {
      delete: DeleteGroup
    },
    GetUsers,
    GetModules,
    AddOrUpdate,
    AddUsers,
    RemoveUsers,
    SetModules,
    GetGroupCheckInSurvey,
    AddGroupSurveyTypes,
    RemoveGroupSurveyTypes
  };
})();

export default Group;